@import '../../../global/polyfills.pcss';

atomic-icon {
  display: inline-block;
  fill: currentColor;
  @mixin aspect-ratio-h 1 / 1, auto;

  > svg {
    width: 100%;
    max-height: 100%;
    @mixin aspect-ratio-h 1 / 1, auto;
  }
}
